export function initialsFor(name: string): string {
	const words = name.split(/\s+/).filter(word => /[A-Za-z]/.test(word));
	if (words.length >= 2) {
		return (words[0][0] + words[1][0]).toUpperCase();
	}
	return (words[0] ?? name).slice(0, 2).toUpperCase();
}
